import { render, staticRenderFns } from "./index.vue?vue&type=template&id=612b5a80&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/opt/buildhome/repo/components/global/Button.vue').default,Modal: require('/opt/buildhome/repo/components/global/Modal/index.vue').default})
